export default "https://yastatic.net/s3/frontend/vconf-frontend/_/default.c858d412.svg";